<template>
    <transition name="modal">
        <div class="dialog-modal-mask">
            <div class="import-panel" @click.stop>
                <div class="dialog-title" v-t="'message.title_csv_import'"/>
                <div class="dialog-body-import">
                    <el-tabs v-model="selectedTabName" type="card" @tab-click="handleTabClick">
                        <el-tab-pane v-for="item in tabItems" :label="item.label" :name="item.name" style="padding:30px">
                            <div v-if="selectedTabName === constants.CSV_ERROR_INFO">
                               <ImportErrorList :returnInfo="csvErrorInfo" :showType="0"></ImportErrorList>
                            </div>
                            <div v-else>
                                <div class="dialog-description" v-html="$t('message.hint_csv_common_bell')"/>
                                <div class="import-step">
                                    <div class="import-step-title" v-t= "{ path: 'message.title_csv_download', args: { version: templateVersion } }"/>
                                    <a :href=getCsvTemplatePath() :download=getCsvFilePath()>
                                        <span class="downloadButton">
                                            <img src="../assets/icon_download.svg" class="button-icon"/><span v-t="'message.button_download'"></span>
                                        </span>
                                    </a>
                                    <span style="padding: 0 0 0 20px;display:inline-block;">
                                        <button class="downloadButton" @click="csvExport()">
                                            <img src="../assets/icon_download.svg" class="button-icon"/><span v-t="'message.button_export'"/>
                                        </button>
                                    </span>
                                    <div class="import-step-title" v-t="'message.title_csv_select_file'"/>
                                    <div class="import-step-description" v-t="'message.hint_csv_note3'"/>
                                    <label for="file_upload">
                                        <img src="../assets/icon_attach.svg" class="button-icon"/><span v-t="'message.action_selection'"/>
                                        <input id="file_upload" @change="selectedFile" type="file" name="file" style="display:none"/>
                                    </label>
                                    <span v-if="showUploadInfo">
                                        <span v-if="uploadFile == null" class='selected-filename' style="opacity: 0.6" v-t= "{ path: 'message.action_selection_file', args: { version: templateVersion } }"/>
                                        <span v-else class='selected-filename'>
                                            {{ uploadFile.name}}
                                        </span>
                                    </span>
                                    <!-- ベル -->
                                    <div v-if="selectedTabName === constants.CSV_BELL">
                                        <div class="import-step-title" v-t="'message.title_csv_import_bell'"/>
                                        <div  v-if="showSample" class="csv-sample" style="width: 1130px;overflow-x:scroll">
                                            <table style="width: 1200px">
                                                <tr style="background-color:#f6f6f6">
                                                    <th width="3%"></th>
                                                    <th width="50px" v-t="'message.item_csv_command'"></th>
                                                    <th width="100px" v-t="'message.item_bell_id'"></th>
                                                    <th width="100px" v-t="'message.item_bell_display_name'"></th>
                                                    <th width="100px" v-t="'message.item_bell_target_group'"></th>
                                                    <th width="100px" v-t="'message.item_bell_notify_lang'"></th>
                                                    <th width="100px" v-t="'message.item_bell_notify_items'"></th>
                                                    <th width="100px" v-t="'message.item_bell_usage_time'"></th>
                                                    <th width="100px" v-t="'message.item_bell_usage_point'"></th>
                                                    <th width="300px" v-t="'message.item_bell_display_setting'"></th>
                                                </tr>
                                                <tr>
                                                    <td style="background-color:#f6f6f6;text-align:center"> 1 </td>
                                                    <td v-t="'message.item_bell_csv_sample_1_command'"/>
                                                    <td v-t="'message.item_bell_csv_sample_1_id'"/>
                                                    <td v-t="'message.item_bell_csv_sample_1_name'"/>
                                                    <td v-t="'message.item_bell_csv_sample_1_groups'"/>
                                                    <td v-t="'message.item_bell_csv_sample_1_notifyLang'"/>
                                                    <td v-t="'message.item_bell_csv_sample_1_notifyItems'"/>
                                                    <td v-t="'message.item_bell_csv_sample_1_usageTime'"/>
                                                    <td v-t="'message.item_bell_csv_sample_1_usagePoint'"/>
                                                    <td v-t="'message.item_bell_csv_sample_1_setting'"/>
                                                </tr>
                                                <tr>
                                                    <td style="background-color:#f6f6f6;text-align:center"> 2 </td>
                                                    <td v-t="'message.item_bell_csv_sample_2_command'"/>
                                                    <td v-t="'message.item_bell_csv_sample_2_id'"/>
                                                    <td v-t="'message.item_bell_csv_sample_2_name'"/>
                                                    <td v-t="'message.item_bell_csv_sample_2_groups'"/>
                                                    <td v-t="'message.item_bell_csv_sample_2_notifyLang'"/>
                                                    <td v-t="'message.item_bell_csv_sample_2_notifyItems'"/>
                                                    <td v-t="'message.item_bell_csv_sample_2_usageTime'"/>
                                                    <td v-t="'message.item_bell_csv_sample_2_usagePoint'"/>
                                                    <td v-t="'message.item_bell_csv_sample_2_setting'"/>
                                                </tr>
                                                <tr>
                                                    <td style="background-color:#f6f6f6;text-align:center"> 3 </td>
                                                    <td v-t="'message.item_bell_csv_sample_3_command'"/>
                                                    <td v-t="'message.item_bell_csv_sample_3_id'"/>
                                                    <td v-t="'message.item_bell_csv_sample_3_name'"/>
                                                    <td v-t="'message.item_bell_csv_sample_3_groups'"/>
                                                    <td v-t="'message.item_bell_csv_sample_3_notifyLang'"/>
                                                    <td v-t="'message.item_bell_csv_sample_3_notifyItems'"/>
                                                    <td v-t="'message.item_bell_csv_sample_3_usageTime'"/>
                                                    <td v-t="'message.item_bell_csv_sample_3_usagePoint'"/>
                                                    <td v-t="'message.item_bell_csv_sample_3_setting'"/>
                                                </tr>
                                                <tr>
                                                    <td style="background-color:#f6f6f6;text-align:center"> 4 </td>
                                                    <td v-t="'message.item_bell_csv_sample_4_command'"/>
                                                    <td v-t="'message.item_bell_csv_sample_4_id'"/>
                                                    <td v-t="'message.item_bell_csv_sample_4_name'"/>
                                                    <td v-t="'message.item_bell_csv_sample_4_groups'"/>
                                                    <td v-t="'message.item_bell_csv_sample_4_notifyLang'"/>
                                                    <td v-t="'message.item_bell_csv_sample_4_notifyItems'"/>
                                                    <td v-t="'message.item_bell_csv_sample_4_usageTime'"/>
                                                    <td v-t="'message.item_bell_csv_sample_4_usagePoint'"/>
                                                    <td v-t="'message.item_bell_csv_sample_4_setting'"/>
                                                </tr>
                                            </table>
                                            <span v-t="'message.item_bell_csv_hint1'"/>
                                            <br>
                                            <span v-t="'message.item_bell_csv_hint2'"/>
                                        </div>
                                    </div>
                                    <!-- 権限ユーザー -->
                                    <div v-else-if="selectedTabName === constants.CSV_BELL_AUTH_USER">
                                        <div class="import-step-title" v-t="'message.title_csv_import_bell_auth_user'"/>
                                        <div  v-if="showSample" class="csv-sample" style="width: 1130px;overflow-x:scroll">
                                            <table style="width: 1100px">
                                                <tr style="background-color:#f6f6f6">
                                                    <th width="3%"></th>
                                                    <th width="30px" v-t="'message.item_csv_command'"></th>
                                                    <th width="80px" v-t="'message.item_bell_id'"></th>
                                                    <th width="80px" v-t="'message.item_userId'"></th>
                                                </tr>
                                                <tr>
                                                    <td style="background-color:#f6f6f6;text-align:center"> 1 </td>
                                                    <td v-t="'message.item_bell_csv_auth_user_sample_1_command'"/>
                                                    <td v-t="'message.item_bell_csv_auth_user_sample_1_id'"/>
                                                    <td v-t="'message.item_bell_csv_auth_user_sample_1_users'"/>
                                                </tr>
                                                <tr>
                                                    <td style="background-color:#f6f6f6;text-align:center"> 2 </td>
                                                    <td v-t="'message.item_bell_csv_auth_user_sample_2_command'"/>
                                                    <td v-t="'message.item_bell_csv_auth_user_sample_2_id'"/>
                                                    <td v-t="'message.item_bell_csv_auth_user_sample_2_users'"/>
                                                </tr>
                                                <tr>
                                                    <td style="background-color:#f6f6f6;text-align:center"> 3 </td>
                                                    <td v-t="'message.item_bell_csv_auth_user_sample_3_command'"/>
                                                    <td v-t="'message.item_bell_csv_auth_user_sample_3_id'"/>
                                                    <td v-t="'message.item_bell_csv_auth_user_sample_3_users'"/>
                                                </tr>
                                                <tr>
                                                    <td style="background-color:#f6f6f6;text-align:center"> 4 </td>
                                                    <td v-t="'message.item_bell_csv_auth_user_sample_4_command'"/>
                                                    <td v-t="'message.item_bell_csv_auth_user_sample_4_id'"/>
                                                    <td v-t="'message.item_bell_csv_auth_user_sample_4_users'"/>
                                                </tr>
                                            </table>
                                            <span v-t="'message.item_bell_csv_auth_user_hint1'"/><br>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </el-tab-pane>
                    </el-tabs>
                </div>
                <hr class="dialog-hr">
                <div class="dialog-button-field">
                    <el-button class="dialog-cancel-button" @click="$emit('cancel')" v-t="'message.button_cancel'"/>
                    <el-button v-if="selectedTabName === constants.CSV_ERROR_INFO" class="dialog-ok-button" @click="$emit('cancel')" v-t="'message.button_end'"/>
                    <el-button v-else class="dialog-ok-button" @click="$emit('import', selectedTabName , uploadFile)" :disabled="disableButton" v-t="'message.button_import'"/>
                </div>
            </div>
        </div>
    </transition>
</template>

<script>
import server from "./ServerApi.js";
import commonUtil from './commonutil.js';
import constants from './constants.js';
import ImportErrorList from './ImportErrorList.vue';

export default {
    components: {
        ImportErrorList
    },

    props: {
        showErrorInfo: Boolean,
        csvResult: Object,
    },

    data() {
        return {
            tabItems: [
                { name: constants.CSV_BELL ,           label: commonUtil.getMessageText(this.$i18n,"item_bell")},
                { name: constants.CSV_BELL_AUTH_USER , label: commonUtil.getMessageText(this.$i18n,"item_bell_auth_user")}
            ],
            showSample: true,
            showUploadInfo: true,
            selectedTabName: "",
            disableButton: true ,
            uploadFile: null ,
            exportData: false,
            csvErrorInfo: null,
            templateVersion: "",
        };
    },

    computed: {
        constants() {
            return constants
        }
    },

    watch: {
        'appData.csvProcessing'(newVal) {
            if (this.appData.csvProcessing) {
                this.disableButton = true;
            } else {
                this.disableButton = false;
                this.getImportProcessState();
            }
        }
    },

    created() {
        if (this.showErrorInfo) {
            this.csvErrorInfo = this.csvResult;
            this.tabItems.push({ name: constants.CSV_ERROR_INFO , label: commonUtil.getMessageText(this.$i18n,"title_error_information") } );
            this.selectedTabName = constants.CSV_ERROR_INFO;
        } else {
            this.selectedTabName = constants.CSV_BELL;
            this.templateVersion = constants.CSV_BELL_TEMPLATE_VERSION;
            this.getImportProcessState();
        }
    },

    methods: {
        selectedFile(e) {
            e.preventDefault();
            let files = e.target.files;
            this.uploadFile = files[0];
            this.disableButton = false;
            this.reDrawUploadInfo();
        },
        handleTabClick(tab , event) {
            this.exportData = false;
            switch(this.selectedTabName) {
                case constants.CSV_BELL:
                    this.templateVersion = constants.CSV_BELL_TEMPLATE_VERSION;
                    break;
                case constants.CSV_BELL_AUTH_USER:
                    this.templateVersion = constants.CSV_BELL_AUTH_USER_TEMPLATE_VERSION;
                    break;
            }
            this.reDrawSample();
        },
        csvExport() {
            this.$emit('export',this.selectedTabName)
        },
        getCsvTemplatePath() {
            switch(this.selectedTabName) {
                case constants.CSV_BELL:
                    if (this.$i18n.locale === "ja") {
                        return "/static/importBellTemplate.csv";
                    } else {
                        return "/static/importBellTemplate_en.csv";
                    }
                case constants.CSV_BELL_AUTH_USER:
                    if (this.$i18n.locale === "ja") {
                        return "/static/importBellAuthUserTemplate.csv";
                    } else {
                        return "/static/importBellAuthUserTemplate_en.csv";
                    }
            }
        },
        getCsvFilePath() {
            switch(this.selectedTabName) {
                case constants.CSV_BELL:
                    return "importBellTemplate.csv";
                case constants.CSV_BELL_AUTH_USER:
                    return "importBellAuthUserTemplate.csv";
            }
        },
        getImportProcessState() {
            let self = this;
            server.post("/getcsvprocstate")
                .then(res => {
                    switch(res.data.status) {
                        case constants.STATUS_SUCCESS:
                            if (!res.data.errorInfo) {
                                return;
                            }
                            if (self.isBellMenuCsvProcessType(res.data.errorInfo.importType) && res.data.errorInfo.errorLineInfo.length > 0) {
                                self.tabItems.push({ name: constants.CSV_ERROR_INFO , label: commonUtil.getMessageText(self.$i18n,"title_error_information")} );
                                self.csvErrorInfo = res.data.errorInfo;
                            }
                            break;
                        default:
                            commonUtil.notifyMessage(self,"Error",commonUtil.getMessageText(self.$i18n,"error_server_api").replace("{functionName}","getImportProcessState").replace("{code}",res.data.status));
                            clearInterval(self.timerObj);
                            break;
                    }
                })
                .catch(err => {
                    commonUtil.putExceptionErrorMessage(self, "getImportProcessState", err);
                    clearInterval(self.timerObj);
                });
        },
        isBellMenuCsvProcessType(type) {
            return type === constants.CSV_BELL || type === constants.CSV_BELL_AUTH_USER;
        },
        reDrawSample() {
            this.showSample = false;
            this.$nextTick(() => {
                 this.showSample = true
            })
        },
        reDrawUploadInfo() {
            this.showUploadInfo = false;
            this.$nextTick(() => {
                 this.showUploadInfo = true
            })
        }
    }
}
</script>

<style scoped>
table {
    margin-top: 10px;
    border-collapse: collapse;
}

table, th, td {
    border: 1px solid #dcdfe6;
    vertical-align: middle;
}

tr {
    height: 2em;
}

th {
    font-size: 12px;
}

td {
    padding-left: 8px;
}

.csv-sample {
    /* margin-top: 20px; */
}

.csv-sample-title {
    opacity: 0.6;
}

.csv-sample-no-use {
    opacity: 0.6;
    text-align: center;
}

button.download {
    height: 35px;
    width: 150px;
    background-color: #f6f6f6;
    border-radius: 4px;
}
label {
    font-size: 14px;
    color: #333B48;
    background-color: #f6f6f6;
    padding: 6px;
    border-radius: 4px;
    border: solid 1px;
    line-height: 33px;
    border-color: #dcdfe6;
    cursor: pointer;
}
.dialog-description {
    padding-top: 16px;
}
.downloadButton {
    line-height: 33px;
    font-size: 14px;
    color: #333B48;
    background-color: #f6f6f6;
    border-radius: 4px;
    border: solid 1px;
    width: 150px;
    border-color: #dcdfe6;
    text-align: center;
    cursor: pointer;
    display: inline-block;
    padding: 0;
    outline: 0;
}
.import-step {
    padding-top: 10px;
    padding-bottom: 10px;
}
.import-step-title {
    padding-top: 32px;
    padding-bottom: 10px;
    font-size: 12px;
    font-weight: bold;
}
.import-step-description {
    padding-bottom: 10px;
}
.selected-filename {
    padding-left: 10px;
}
.button-icon {
    height: 18px;
    vertical-align: middle;
    margin-right: 4px;
}
.el-tabs--border-card {
    box-shadow: none !important;
}
.el-tabs--border-card >>> .el-tabs__header .el-tabs__item:not(.is-disabled):hover {
    color: #5171cb !important;
}
.el-tabs--border-card >>> .el-tabs__header .el-tabs__item.is-active {
    color: #5171cb !important;
}
.el-tabs >>> .el-tabs__content {
    min-height: 520px;
}

a:link { color: #333B48; }
a:visited { color: #333B48; }
a:hover { color: #333B48; }
a:active { color: #333B48; }
a { text-decoration: none; }

.link-yes {
    color: #5171cb;
    padding-top: 10px;
    padding-bottom: 10px;
    font-size: 14px;
}

.arrow_box {
	position: relative;
	background: #fff;
	border: 1px solid #ddd;
	padding-top: 10px;
	padding-bottom: 10px;
    font-size: 14px;
    border-radius: 4px;
}
.arrow_box:after, .arrow_box:before {
	top: 100%;
	left: 50%;
	border: solid transparent;
	content: " ";
	height: 0;
	width: 0;
	position: absolute;
	pointer-events: none;
}

.arrow_box:after {
	border-color: rgba(255, 255, 255, 0);
	border-top-color: #fff;
	border-width: 10px;
	margin-left: -10px;
}
.arrow_box:before {
	border-color: rgba(0, 0, 0, 0);
	border-top-color: #ddd;
	border-width: 11px;
	margin-left: -11px;
}
</style>
